import { extend } from "vee-validate";
import config from "@/js/const";
import { nullToEmpty } from "@/js/utils";
import { isNumeric } from "@/js/validate";
import { ErrorTodoMessages } from "@/js/constants/error-messages";

const Validation = {
  install: Vue => {
    Vue.prototype.$validation = {
      rules: {
        required: value => !!value || ErrorTodoMessages.ERWE40004,
        numeric: value => numeric(value) || ErrorTodoMessages.ERWE40008,
        loginId: value =>
          /^[0-9]{3}$/.test(value) || ErrorTodoMessages.ERWE40015(3)
      }
    };
  }
};

const numeric = value => {
  if (nullToEmpty(value) === "") {
    return true;
  }
  return isNumeric(value);
};

/**
 * カスタムルール（ファイル拡張子チェック）
 */
extend("validExtensions", {
  message: "拡張子が有効ではありません",
  validate(value) {
    if (value) {
      if (value instanceof File) {
        const acceptExtensions = config.FILE_INPUT_ACCEPT.split(",");
        const isValid = acceptExtensions.some(extension => {
          const re = new RegExp("\\" + extension + "$", "i"); // i:大文字小文字を区別しない
          return re.test(value.name);
        });
        return isValid;
      } else {
        return false;
      }
    }
    return true;
  }
});

export default Validation;
